const DEFAULT_ELEMENT = "actionsHtml"

export function parseComponentTokenId(tokenId) {
    if (!tokenId?.startsWith("cmp:")) return null
    const rest = tokenId.slice(4)
    const separatorIndex = rest.indexOf("::")
    if (separatorIndex === -1) {
        return { taskId: rest, element: DEFAULT_ELEMENT }
    }
    const taskId = rest.slice(0, separatorIndex)
    const element = rest.slice(separatorIndex + 2)
    return { taskId, element }
}
